import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {useTranslation} from "react-i18next";
import { useBrandAppearance } from "../hooks/useBrandAppearance";

const GuestPlaceholderBanner: React.FC = () => {

    const { colors: BrandColors } = useBrandAppearance();
    const { t } = useTranslation("guest_card");

    return (
        <Box
            sx={{
                backgroundColor: BrandColors.guestPlaceholderBanner,
                height: "40px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 2,
            }}
        >
            <Typography
                sx={{
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    color: "var(--oc-text)",
                    flexGrow: 1,
                }}
            >
                {t("banner_info_text")}
            </Typography>
            <InfoOutlinedIcon sx={{ color: "#7C624B", fontSize: "1.2rem" }} />
        </Box>
    );
};

export default GuestPlaceholderBanner;
